module.exports = __webpack_public_path__ + "static/media/lightblades-installation-by-lucastswick-sm-15.e5a7b08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightblades/lightblades-installation-by-lucastswick-sm-15.jpg
// module id = 4325
// module chunks = 13